import type { ChatMessage } from "../types";

export const isUploadInFlight = (messages: ChatMessage[]): boolean =>
	messages.some(
		(message) =>
			message.attachment?.state === "uploading" ||
			(!!message.attachment?.importTaskId && !message.attachment.importComplete)
	);
